import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { HttpParamsBuilder, RestClientPaged } from '@elderbyte/ngx-starter'
import { environment } from '../../../../environments/environment'
import { WorkCenter } from './work-center'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class WorkCenterService extends RestClientPaged<WorkCenter, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/work-centers', http, {
      idField: 'id',
    })
  }

  public archive(workCenter: WorkCenter, deleteUnused: boolean): Observable<WorkCenter> {
    const params = new HttpParams().set('deleteUnused', deleteUnused)
    return this.delete(workCenter, params)
  }
}
